import { AdaptiveStack } from '@partiu/ui/components/atoms/AdaptiveStack.tsx';
import { Card } from '@partiu/ui/components/atoms/Card.tsx';
import { useForm } from 'react-hook-form';
import {
  Button,
  Checkbox,
  Flex,
  Image,
  Text,
  Textarea,
  VStack,
  Divider,
  Input,
  Spacer,
  useToast,
} from '@chakra-ui/react';
import { Labeled } from '@partiu/ui/components/molecules/Labeled.tsx';
import { useState } from 'react';
import { DashboardTemplate } from '../components/templates/DashboardTemplate.tsx';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider.tsx';
import { useSendAgreementEmailMutation } from '@partiu/api/dashboard/hooks.ts';
import { IAgreementEmail } from '@partiu/api/dashboard/types.ts';

export function CustomEmailPage() {
  const toast = useToast();
  const { name, colors, logo } = useTheme();
  const { register, handleSubmit, watch, reset } = useForm({
    defaultValues: {
      subject: 'Você agora faz parte do Clube ' + name,
      title: 'Você agora faz parte do Clube ' + name,
      emailList: '',
      text: `Olá, tudo bem?\n\n<b>Temos uma ótima notícia!</b>\n\n\Gostaríamos de apresentar a você o nosso Programa de Relacionamento com o cliente.\n\nCom o <b>Clube ${name}</b> você e sua família terão acesso a um mundo de vantagens, como descontos em várias grandes marcas ecommerce, cinemas, lojas físicas, livros digitais, entre outros.\n\n\E o melhor, cliente ${name} é <b>gratuito</b>, veja como é simples:\n\n1. Faça download do app no link abaixo.\n2. Clique em "Com CPF Vinculado".\n3. Insira suas informações e aproveite!\n\nAtenciosamente,\n\n<b>Equipe Clube ${name}</b>`,
    },
  });
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const title = watch('title');
  const text = watch('text');
  const emailList = watch('emailList');
  const mutation = useSendAgreementEmailMutation({
    onSuccess() {
      reset();
      setAcceptedTerms(false);
      toast({
        title: 'Sucesso!',
        description:
          'Email enviado com sucesso. É possível que o email demore alguns minutos dependendo da quantidade de recipientes.',
        status: 'success',
      });
    },
    onError() {
      toast({
        title: 'Erro',
        description: 'Não foi possível enviar o email. Por favor entre em contato em: suporte@partiu.com.br',
        status: 'error',
      });
    },
  });

  return (
    <DashboardTemplate title={'Envio de Email Promocional'}>
      <AdaptiveStack width={'100%'} spacing={10} padding={4}>
        <Card width={{ base: '100%', lg: '600px' }} title="Enviar Email">
          <form style={{ height: '100%' }} onSubmit={handleSubmit((data) => mutation.mutate(data as IAgreementEmail))}>
            <VStack height={'100%'} spacing={5}>
              <Labeled label={'Assunto'}>
                <Input {...register('subject', { required: true })} />
              </Labeled>
              <Labeled label={'Título'}>
                <Input {...register('title', { required: true })} />
              </Labeled>
              <Labeled label={'Texto'}>
                <Textarea minHeight={'150px'} {...register('text', { required: true })} />
              </Labeled>
              <Labeled
                label={'Lista de Emails'}
                helpText={'Insira os emails aqui. Cada email deve estar em uma linha'}
                footerText={emailList.split('\n').filter((s) => s !== '').length + ' emails.'}
              >
                <Textarea minHeight={'150px'} {...register('emailList', { required: true })} />
              </Labeled>
              <Spacer />
              <Checkbox isChecked={acceptedTerms} onChange={(e) => setAcceptedTerms(e.target.checked)}>
                Estou ciente de que o conteúdo do email é de minha responsabilidade
              </Checkbox>
              <Button
                marginTop={'auto'}
                width={'100%'}
                colorScheme={'green'}
                isDisabled={!acceptedTerms}
                type={'submit'}
                isLoading={mutation.isLoading}
              >
                Enviar
              </Button>
            </VStack>
          </form>
        </Card>
        <Card title={'Visualização'} maxWidth={"500px"}>
          <VStack minHeight="600px" backgroundPosition="top-left" width="100%" spacing={0}>
            <Flex
              flexDir="column"
              padding={0}
              justifyContent={'center'}
              alignItems={'center'}
              backgroundColor="white"
              borderRadius="5%"
              wordBreak="normal"
              overflowWrap="break-word"
              width="100%"
            >
              <Text marginBottom="16px">Seu Clube de Vantagens tem uma novidade para você:</Text>
              <Image src={logo} style={{ objectFit: 'contain', maxHeight: '80px' }} />
              <Divider backgroundColor={colors.primaryColor} padding={'2px'} margin={'16px 0'} />
              <Flex flexDir="column" px={2} justifyContent="center" padding={'16px'} align={'center'}>
                <Text fontWeight="bold">{title}</Text>
                <Text>
                  <div dangerouslySetInnerHTML={{ __html: text.replaceAll('\n', '<br/>') }} />
                </Text>
              </Flex>
              <Flex padding="16px 0">
                <Button backgroundColor={colors.primaryColor} textColor={colors.primaryFontColor}>
                  Clique aqui e use agora!
                </Button>
              </Flex>
              <Flex
                backgroundColor={colors.primaryColor}
                textColor={colors.primaryFontColor}
                width={'100%'}
                justifyContent={'space-between'}
                minHeight={'100px'}
              >
                <Text
                  padding={'4px'}
                  width="50%"
                  wordBreak={'break-word'}
                  textAlign={'center'}
                  fontSize={'1.5em'}
                  fontWeight={'bold'}
                  margin="auto"
                >
                  Baixe nosso app
                </Text>
                <Flex
                  backgroundColor={colors.primaryColor}
                  textColor={colors.primaryFontColor}
                  width={'100%'}
                  justifyContent={'space-around'}
                >
                  <Image
                    src={'https://partiu-static.s3.amazonaws.com/badge/googleplay.png'}
                    style={{ objectFit: 'contain', maxWidth: '40%' }}
                  />
                  <Image
                    src={'https://partiu-static.s3.amazonaws.com/badge/appstore.png'}
                    style={{ objectFit: 'contain', maxWidth: '40%' }}
                  />
                </Flex>
              </Flex>
            </Flex>
          </VStack>
        </Card>
      </AdaptiveStack>
    </DashboardTemplate>
  );
}
